import { render, staticRenderFns } from "./form-user.vue?vue&type=template&id=31c7a304&scoped=true"
import script from "./form-user.vue?vue&type=script&lang=js"
export * from "./form-user.vue?vue&type=script&lang=js"
import style0 from "./form-user.vue?vue&type=style&index=0&id=31c7a304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7a304",
  null
  
)

export default component.exports